module.exports = __webpack_public_path__ + "static/shutterstock_653993329.14b4d28e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shutterstock_653993329.jpg
// module id = 631
// module chunks = 35783957827783